<template>
    <form v-loading="loading" @submit.prevent="submit">
        <text-input
            v-model="phoneNumber"
            validations="required|min:8|max:15"
            name="phone_number"
            type="tel"
            :label="lang('Telefonnummer','Phone number')"
            :tabindex="1"
        />
        <text-input
            v-if="customerMessageFieldTitle"
            v-model="customerMessage"
            validations="required"
            name="customer_message"
            type="text"
            :label="customerMessageFieldTitle"
            :tabindex="1"
        />
        <div class="textfield-select">
            <select-input
                v-model="selectedCallSlot"
                name="call_slot"
                :options="callSlotOptions"
                :placeholder="lang('Välj tid att bli uppringd','Select a time when you want us to call')"
                :required="true"
                :tabindex="1"
            />
        </div>
        <div v-if="success" class="text-success">
            <font-awesome-icon icon="check-circle" />
            {{ lang('Tack!','Thank you!') }}
            <br>{{ success }}
        </div>
        <div v-else class="text-center">
            <button
                type="submit"
                class="btn btn-lg is-ghost"
                tabindex="1"
            >
                <span>{{ lang('Ring mig','Call me') }}</span>
            </button>
        </div>
        <div v-if="error" class="text-danger mt-md">
            <font-awesome-icon icon="exclamation-circle" />
            {{ lang('Ojdå!','Whoops!') }}
            <br>{{ error }}
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            callSlotOptions: {
                required: true,
                type: Array,
            },
            queueId: {
                required: true,
                type: String,
            },
            customerMessageFieldTitle: {
                required: false,
                type: String,
                default: '',
            },
        },
        data() {
            return {
                success: '',
                error: '',
                loading: '',
                selectedCallSlot: '',
                name: '',
                phoneNumber: '',
                customerMessage: '',
            };
        },
        methods: {
            submit() {
                this.loading = true;
                axios.post(this.route('front.api.customer-service.schedule-call-to-customer'), {
                    phone_number: this.phoneNumber,
                    name: this.name,
                    call_slot: this.selectedCallSlot,
                    customer_message: this.customerMessage,
                    queue_id: this.queueId,
                })
                    .then(response => {
                        this.loading = false;

                        this.success = response.data.message;
                        this.error = false;

                        this.name = '';
                        this.phoneNumber = '';
                        this.customer_message = '';
                    })
                    .catch(error => {
                        this.loading = false;
                        this.success = false;

                        if (error.response.status === 422) {
                            const errors = Object.values(error.response.data.errors);
                            this.error = errors.join();
                        } else {
                            this.error = error.response.data.message;
                        }
                    });
            },
        },
    };
</script>
